import * as React from 'react';
import { usePremium } from '../../premium/PremiumContext';

const POPUP_AD = {
  name: 'popup',
  variableName: 'fkw',
  src: '//tiny-ambition.com/ciDI9E6.bW2k5Ml/SdWHQ/9/N/zNEyzTMhTfIb2/MfSu0E3_MNT/M/xOMIjzYo1t'
};

export default function PopupAd() {
  const scriptLoadedRef = React.useRef(false);
  const { isPremium, premiumLoading } = usePremium();

  React.useEffect(() => {
    if (premiumLoading || isPremium) {
      return undefined;
    }

    if (scriptLoadedRef.current) {
      return undefined;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.dataset.adName = POPUP_AD.name;
    script.text = `(function(${POPUP_AD.variableName}){\nvar d = document,\n    s = d.createElement('script'),\n    l = d.scripts[d.scripts.length - 1];\ns.settings = ${POPUP_AD.variableName} || {};\ns.src = "${POPUP_AD.src}";\ns.async = true;\ns.referrerPolicy = 'no-referrer-when-downgrade';\nl.parentNode.insertBefore(s, l);\n})({})`;

    document.body.appendChild(script);
    scriptLoadedRef.current = true;

    return () => {
      script.remove();
      scriptLoadedRef.current = false;
    };
  }, [isPremium, premiumLoading]);

  if (premiumLoading || isPremium) {
    return null;
  }

  return null;
}
